<app-dialog-close-button class="close-button" (closed)="close()"></app-dialog-close-button>
<div *ngIf="!isLoading">
    <h3 style="font-size: 20px;">
        Word Count
    </h3>

    <hr>

    <p style="font-size: 15px; font-weight: 600; margin-bottom: 2rem;">Statistics:</p>

    <!-- <br> -->

    <div style="display: flex; justify-content: space-between">
        <p style="font-weight: 400; font-size: 15px; margin: 0;">Words</p>
        <p style="font-weight: 400; font-size: 15px; margin: 0;">{{countWords()}}</p>
    </div>
    <div style="display: flex; justify-content: space-between">
        <p style="font-weight: 400; font-size: 15px; margin: 0;">Characters (no spaces)</p>
        <p style="font-weight: 400; font-size: 15px; margin: 0;">{{countCharWithoutSpaces()}}</p>
    </div>
    <div style="display: flex; justify-content: space-between">
        <p style="font-weight: 400; font-size: 15px; margin: 0;">Characters (with spaces)</p>
        <p style="font-weight: 400; font-size: 15px; margin: 0;">{{countCharWithSpaces()}}</p>
    </div>
    <div style="display: flex; justify-content: space-between">
        <p style="font-weight: 400; font-size: 15px; margin: 0;">Paragraphs</p>
        <p style="font-weight: 400; font-size: 15px; margin: 0;">{{countParagraphs()}}</p>
    </div>
    <div style="display: flex; justify-content: space-between">
        <p style="font-weight: 400; font-size: 15px; margin: 0;">Lines</p>
        <p style="font-weight: 400; font-size: 15px; margin: 0;">{{countLines()}}</p>
    </div>
    
    
    
    

    <br>
    <div style="display: flex; justify-content: center; align-items: center">
        <button type="button" vng-button variant="primary" tabindex="-1" (click)="close()" style="width: 108px;">
            Close
        </button>
    </div>
</div>